import { useRef, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
const SR_LANG = { English: "en-IN", Hindi: "hi-IN", Hinglish: "hi-IN" };

export const useSpeechInput = ({ lang, text, setText }) => {
  const [recording, setRecording] = useState(false);
  const [refining, setRefining] = useState(false);
  const [stream, setStream] = useState(null);
  const rec = useRef(null);
  const finalRef = useRef("");

  const stop = () => rec.current?.stop();

  const start = async () => {
    if (!SR) return toast.error("Speech recognition is not supported in this browser. Try Chrome.");
    let s;
    try {
      s = await navigator.mediaDevices.getUserMedia({ audio: true });
      setStream(s);
    } catch {
      return toast.error("Microphone permission denied");
    }
    const base = text.trim();
    const join = (tail) => [base, tail].filter(Boolean).join(" ");
    finalRef.current = "";
    const r = new SR();
    r.lang = SR_LANG[lang];
    r.continuous = true;
    r.interimResults = true;
    r.onresult = (e) => {
      let interim = "";
      for (let i = e.resultIndex; i < e.results.length; i++) {
        const t = e.results[i][0].transcript;
        if (e.results[i].isFinal) finalRef.current += t + " ";
        else interim += t;
      }
      setText(join(finalRef.current + interim));
    };
    r.onerror = (e) => e.error !== "aborted" && toast.error(`Speech error: ${e.error}`);
    r.onend = async () => {
      s.getTracks().forEach((t) => t.stop());
      setStream(null);
      setRecording(false);
      const raw = finalRef.current.trim();
      if (!raw) return;
      setRefining(true);
      try {
        const res = await api.post("/refine", { text: raw, language: lang });
        setText(join(res.data.text));
      } catch {
        setText(join(raw));
      } finally {
        setRefining(false);
      }
    };
    rec.current = r;
    r.start();
    setRecording(true);
  };

  return { recording, refining, stream, start, stop };
};
